module.exports = __webpack_public_path__ + "static/img/ureter-4.cae309f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/ureterpic/ureter-4.jpg
// module id = FvFs
// module chunks = 51